import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import iframeDetector from '../../utils/IframeDetector';

/**
 * IframeProtection Component
 * 
 * This component blocks access to protected routes when running inside an iframe.
 * It performs multiple checks and redirects to home if iframe is detected.
 * 
 * Usage: Wrap this around any route that should not be accessible in an iframe
 */
export default function IframeProtection({ children, redirectTo = '/' }) {
  const navigate = useNavigate();

  useEffect(() => {
    // Perform immediate check
    const isInIframe = iframeDetector.isInIframe();

    if (isInIframe) {
      // Redirect immediately
      navigate(redirectTo, { replace: true });
      return;
    }

    // Set up continuous monitoring
    const checkInterval = setInterval(() => {
      iframeDetector.redetect();
      const currentState = iframeDetector.isInIframe();

      if (currentState) {
        navigate(redirectTo, { replace: true });
      }
    }, 1000);

    return () => clearInterval(checkInterval);
  }, [navigate, redirectTo]);

  // If not in iframe, render children
  if (!iframeDetector.isInIframe()) {
    return children;
  }

  // If in iframe, don't render anything (will redirect)
  return null;
}

